// extracted by mini-css-extract-plugin
module.exports = {"container":"Assessments_container__1-wzA","loading":"Assessments_loading__U37W9"};